import { FunctionComponent } from 'react';
import '../../../css/PublicAboutUsPage.css';

const Component08: FunctionComponent = () => {
  return (
    <div className='public-about-us-page-component-eight-container vdr-about-panel'>
      <div className='vdr-about-cta'>
        <span className='vdr-eyebrow vdr-eyebrow--bar vdr-eyebrow--on-dark'>Contacto</span>
        <h2 className='public-about-us-page-subtitle-text'>Llamado a la acción</h2>
        <p className='public-about-us-page-text'>
          Si deseas saber más sobre nuestra visión, nuestros productos o cómo podemos ayudarte a
          mejorar la gestión de tu red eléctrica, no dudes en contactarnos. ¡Juntos podemos crear
          soluciones innovadoras para un futuro energético más eficiente!
        </p>
      </div>
    </div>
  );
};

export default Component08;
